import HeightEqualizer from "parent/src/js/base/Controllers/HeightEqualizer";

export default class EqualHeightElementCollection {
	constructor(isInstant = false) {
		this.selector = this.getSelector();
		this.delayedElementIds = [];

		if (isInstant) {
			this.init();
		}
		else {
			window.addEventListener("load", () => {
				this.init();
			});
		}
	}

	init() {
		this.matchHeight().finally(() => {
			this.afterMatchHeight();
			window.addEventListener("scroll", this.onWindowScroll.bind(this), {
				passive: true
			});
		});
	}

	/**
	 * @return {string}
	 */
	getSelector() {
		return "";
	}

	/**
	 * @type {NodeListOf<HTMLElement>[]}
	 */
	getComponents() {
		return [];
	}

	matchHeight() {
		return new Promise(resolve => {

			let components = this.getComponents();
			let numMatched = 0;

			components.forEach(els => {
				if (els.length > 0) {
					new HeightEqualizer(els);
					els.forEach(el => {
						el.addEventListener(HeightEqualizer.FinishEvent, e => {
							numMatched++;
							if (numMatched === components.length) {
								resolve();
							}
						});
					});
				}
			});
		});
	}

	afterMatchHeight() {

	}

	/**
	 *
	 * @param {Event} evt
	 */
	onWindowScroll(evt) {
		this.afterMatchHeight();
	}
}
